import OrganisationsSelect from '../../../elements/Select/Organistaions'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import CustomTable from '../../../elements/Table/CustomTable'
import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'

const columns = [
  {
    Header: 'Code',
    accessor: 'code',
    width: 150,
    // Cell: ({value, original}) => (
    //   <Link
    //     to={{
    //       pathname: `/hseq/mrn/${original._key}/update`,
    //     }}>
    //     {value}
    //   </Link>
    // ),
  },

  { Header: 'Vendor', accessor: 'vendor.fn', width: 250 },
  { Header: 'Status', accessor: 'status', Cell: StatusCell, width: 150 },
]

function StockList (props) {
  const { list, fetch, fetching, company, onChangeCompany, hideCompany, hideCreate } = props

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      ExtraOptionsButtons={() =>
        hideCompany !== true && (
          <OrganisationsSelect
            value={company}
            onChange={onChangeCompany}
            placeholder={'Filter by a company'}
            size={'small'}
            style={{ width: '450px', paddingRight: 20, float: 'right' }}
          />
        )
      }
      // CreateButton={() =>
      //   hideCreate !== true && (
      //     <Button
      //       type={'primary'}
      //       size="small"
      //       icon={'plus'}
      //       onClick={() => {
      //         props.history.push({
      //           pathname: `/purchasing/stock/new/`,
      //         })
      //       }}>
      //       New
      //     </Button>
      //   )
      // }
      columns={columns}
    />
  )
}

StockList.propTypes = {
  list: PropTypes.any,
  fetch: PropTypes.any,
  fetching: PropTypes.any,
  company: PropTypes.any,
  onChangeCompany: PropTypes.any,
  hideCompany: PropTypes.bool,
}
StockList.defaultProps = {}

export default withRouter(StockList)
